import { createSlice } from "@reduxjs/toolkit";
import {
  CreatecustomeraccessThunk,
  DeletecustomeraccessThunk,
  fetchApprovalCustomerByid,
  fetchAprrovalCustomersByUserId,
  fetchCreditLineCustomersByUserId,
  fetchCustomerAccessAsync,
  fetchCustomersBySellerId,
  fetchCustomerThunkDetails,
  fetchExistingCustomer,
  getAccountStatment,
  getAllCustomerPayments,
  getCreditNote,
  getCustomerDashbaord,
  getCustomerInvoice,
  getCustomerPayment,
  getLogisticDetails,
  registerCustomer
} from "../thunks/customerThunks";
import { fetchPodDatesThunk } from "../thunks/logisticThunks";

const initialState = {
  loading: false,
  error: null,
  success: false,
  allCustomers: null,
  allExistingCustomer: null,
  customersForApproval: null,
  creditLineForApproval: null,
  customerApprovalStatus: null,
  ViewAccountStatment: null,
  ViewCustomerInvoices: null,
  ViewCreditNote: null,
  ViewPaymentDetails: null,
  ViewLogisticDetails: null,
  ViewCustomerDashboard: null,
  AllCustomerPaymentDetails: null,
  podDates: [],
  AddcustomerAccess: [],
  CustomerDetails:[],
  activeCustomerDetails:null, 
  podDatesLoading: false,
  podDatesError: null,
  customerAccessByUsersData: null,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetCustomerStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(registerCustomer.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(registerCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Registration failed.";
      })

      .addCase(fetchCustomersBySellerId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomersBySellerId.fulfilled, (state, action) => {
        state.loading = false;
        state.allCustomers = action.payload;
      })
      .addCase(fetchCustomersBySellerId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(fetchAprrovalCustomersByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAprrovalCustomersByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.customersForApproval = action.payload;
      })
      .addCase(fetchAprrovalCustomersByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(fetchCreditLineCustomersByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreditLineCustomersByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.creditLineForApproval = action.payload;
      })
      .addCase(fetchCreditLineCustomersByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })

      .addCase(fetchExistingCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExistingCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.allExistingCustomer = action.payload;
      })
      .addCase(fetchExistingCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })

      .addCase(fetchApprovalCustomerByid.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovalCustomerByid.fulfilled, (state, action) => {
        state.loading = false;
        state.customerApprovalStatus = action.payload;
      })
      .addCase(fetchApprovalCustomerByid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getAccountStatment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAccountStatment.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewAccountStatment = action.payload;
      })
      .addCase(getAccountStatment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getCustomerInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewCustomerInvoices = action.payload;
      })
      .addCase(getCustomerInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getCreditNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCreditNote.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewCreditNote = action.payload;
      })
      .addCase(getCreditNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getCustomerPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewPaymentDetails = action.payload;
      })
      .addCase(getCustomerPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getLogisticDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLogisticDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewLogisticDetails = action.payload;
      })
      .addCase(getLogisticDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getCustomerDashbaord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerDashbaord.fulfilled, (state, action) => {
        state.loading = false;
        state.ViewCustomerDashboard = action.payload;
      })
      .addCase(getCustomerDashbaord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers.";
      })
      .addCase(getAllCustomerPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCustomerPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.AllCustomerPaymentDetails = action.payload;
      })
      .addCase(getAllCustomerPayments.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to fetch all customer payments.";
      })
      .addCase(fetchPodDatesThunk.pending, (state) => {
        state.podDatesLoading = true;
        state.podDatesError = null;
      })
      .addCase(fetchPodDatesThunk.fulfilled, (state, action) => {
        state.podDatesLoading = false;
        state.podDates = action.payload || [];
      })
      .addCase(fetchPodDatesThunk.rejected, (state, action) => {
        state.podDatesLoading = false;
        state.podDatesError = action.payload || "Failed to fetch POD dates";
      })
      .addCase(CreatecustomeraccessThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CreatecustomeraccessThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.AddcustomerAccess.push(action.payload);
      })
      .addCase(CreatecustomeraccessThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCustomerAccessAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerAccessAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAccessByUsersData = action.payload;
      })
      .addCase(fetchCustomerAccessAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })



        .addCase(fetchCustomerThunkDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerThunkDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.activeCustomerDetails= action.payload.activeCustomerCounts;
        state.CustomerDetails = action.payload.activeCustomerReports;
      })
      .addCase(fetchCustomerThunkDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(DeletecustomeraccessThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DeletecustomeraccessThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAccessByUsersData =
          state.customerAccessByUsersData.filter(
            (item) => item.customer_Id !== action.payload
          );
      })
      .addCase(DeletecustomeraccessThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCustomerStatus } = customerSlice.actions;
export default customerSlice.reducer;

// Selector to map invoiceNumber to podDate
export const selectPodDateAndStatusByInvoice = (state) => {
  const map = {};
  (state.customer.podDates || []).forEach((item) => {
    map[item.invoiceNumber] = {
      podDate: item.podDate,
      status: item.status, // or item.status depending on API
    };
  });
  return map;
};
